import { useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";

// Shared query-client policy. The root instance serves auth/org bootstrap;
// OrgScopedQueryBoundary creates page-data instances from the same policy.

export function createDashboardQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // Don't retry on client errors — those don't get better.
        retry: (failureCount, error: unknown) => {
          const status = (error as { response?: { status?: number } })?.response?.status;
          if (status && status >= 400 && status < 500) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
    },
  });
}

export function QueryClientProvider({ children }: { children: ReactNode }) {
  const [client] = useState(createDashboardQueryClient);
  return <TanstackQueryClientProvider client={client}>{children}</TanstackQueryClientProvider>;
}
